<template>
    <section class="section">
        <div class="columns">

            <div class="column">

                <h1 class="title has-text-centered">
                    Je me connecte
                </h1>
                <div class="field">
                    <label class="label">Adresse mail</label>
                    <div class="control">
                        <input type="text" :class="email_error ? 'input is-danger is-rounded' : 'input is-rounded'" name="" id="" v-model="email" autocomplete="off">
                    </div>
                    <p class="help is-danger">{{email_error}}</p>
                </div>

                <div class="field">
                    <label class="label">Mot de passe</label>
                    <div class="control">
                        <input type="password" :class="password_error ? 'input is-danger is-rounded' : 'input is-rounded'" name="" id="" v-model="password" autocomplete="off">
                    </div>
                    <p class="help is-danger">{{password_error}}</p>
                </div>

                <p class="help is-danger">{{form_error}}</p>
                <p class="help">Mot de passe oublié ? <span class="has-text-info is-clickable" @click="$emit('forgottenPassword')">Cliquez ici</span></p>
                <div class="buttons mt-5 is-justify-content-center">
                    <button id="btn-signin" class="button is-rounded is-info has-text-weight-bold" @click="tryLogin">
                        Me connecter
                    </button>
                </div>
            </div>

            <div class="vertical-separator"></div>

            <div class="column is-flex is-align-items-center is-justify-content-center is-narrow-mobile">
                <div v-if="$page.props.config.disabled_fo_signup" class="column is-flex-direction-column is-flex is-align-items-center is-justify-content-center py-0">
                    <button id="btn-signup" class="button is-info is-rounded  has-text-weight-bold" disabled>
                        Je m'inscris
                    </button>
                    <p class="help is-danger has-text-centered">
                        L'inscription en ligne est desactivée, pour prendre rendez-vous en ligne merci de contacter le secrétariat.
                    </p>
                </div>

                <button id="btn-signup" class="button is-info is-rounded  has-text-weight-bold" v-else @click="$emit('showSignUp')">
                    Je m'inscris
                </button>
            </div>

        </div>

    </section>
</template>

<script>
import axios from 'axios'
export default {
    name: 'SignIn',
    data () {
        return {
            email: null,
            email_error: null,
            form_error: null,
            password: null,
            password_error: null
        }
    },
    methods : {
        toggleModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        tryLogin () {
            if (!this.email || !this.email.trim()) {
                this.email_error = "Merci de renseigner l'adresse mail."
                return false
            }
            const mail_reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!mail_reg.test(String(this.email).toLowerCase())) {
                this.email_error = "L'adresse mail est incorrecte."
                return false
            }
            this.email_error = null
            if (!this.password || !this.password.trim()) {
                this.password_error = "Le mot de passe est requis"
                return false
            }
            this.password_error = null
            axios.post('/auth/login', {
                email: this.email,
                password: this.password
            })
            .then(response => {
                this.form_error = null
                let user = response.data.client
                console.log('user login')
                this.$emit('userLogin', user)
                this.toggleModal()
            })
            .catch(err => {
                this.form_error = err?.response?.data?.message ?? 'Une erreur est survenue'
                console.log(err)
            })
        }
    }
}
</script>

<style scoped>
    #btn-signin {
        background-color: var(--btn-primary-bg-color);
        color: var(--btn-primary-text-color);
    }

    #btn-signin:hover {
        background-color: var(--btn-primary-bg-color-hover);
        color: var(--btn-primary-text-color);
    }

    #btn-signup {
        background-color: var(--btn-secondary-bg-color);
        color: var(--btn-secondary-text-color);
    }

    #btn-signup:hover {
        background-color: var(--btn-secondary-bg-color-hover);
        color: var(--btn-secondary-text-color);
    }
</style>
